// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"style_breadcrumb__3uVeg","breadcrumbLink":"style_breadcrumbLink__26UIc"};